import React, { useEffect, useState } from 'react';
import './Preloader.css';
import logo from '../../assets/images/logo.jpg';

const Preloader = () => {
    const [loading, setLoading] = useState(true);
    const [fadeOut, setFadeOut] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setFadeOut(true);
            setTimeout(() => setLoading(false), 800);
        }, 2000);

        return () => clearTimeout(timer);
    }, []);

    if (!loading) return null;

    return (
        <div className={`preloader ${fadeOut ? 'preloader--fade-out' : ''}`}>
            <div className="preloader__content">
                <div className="preloader__logo-container">
                    <img src={logo} alt="Da Vinci Logo" className="preloader__logo" />
                    <div className="preloader__ring"></div>
                </div>
                <h1 className="preloader__title">Da Vinci Institute</h1>
                <div className="preloader__progress">
                    <div className="preloader__bar"></div>
                </div>
            </div>
        </div>
    );
};

export default Preloader;
